import { RootState } from '../store';

export const selectStaffCaseCreation = (state: RootState) => state.staffCaseCreation;
